import { PaymentMethodsResponse } from 'models/PaymentProcessor'
import { api, usePrefetchNow } from '../api'

export const paymentMethodsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethods: builder.query<
      PaymentMethodsResponse,
      { campaignId: string; currency: string }
    >({
      query: ({ campaignId, currency }) =>
        `/campaigns/${campaignId}/payment-methods?currency=${currency}`,
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { getPaymentMethods },
  useGetPaymentMethodsQuery,
} = paymentMethodsApi

export const usePrefetchPaymentMethods = (campaignId: string, currency: string) =>
  usePrefetchNow(getPaymentMethods, { campaignId, currency }, !!campaignId)
